import React from 'react';
import { useHistory } from 'react-router';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Controller, useForm } from 'react-hook-form';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { postResetPassword } from '../store/actions/user/userActions';
import { PAGES } from '../constants/pages';
import {
  FormContainer,
  FormWrap,
} from '../components/FormContainer/FormContainer';
import BaseLayout from '../components/BaseLayout';
import ForgotPasswordCard from '../components/ForgotPassword/ForgotPasswordCard';
import BaseLayoutCta from '../components/BaseLayoutCta/BaseLayoutCta';
import PasswordInput from '../components/Fields/PasswordInput';
import useQuery from '../util/hooks/useQuery';
import { getValidationSchema } from '../util/helpers/getValidationSchema';

const ResetPasswordPage = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const dispatch = useDispatch();
  const query = useQuery();
  const { rpt } = query;

  const formValidationSchema = yup.object({
    ...getValidationSchema({
      fields: ['Password'],
    }),
  });

  const { handleSubmit, setError, control } = useForm({
    defaultValues: { Password: '' },
    resolver: yupResolver(formValidationSchema),
  });

  const onSubmit = (data) => {
    const payload = {
      PasswordResetToken: rpt,
      NewPassword: data.Password,
    };
    dispatch(
      postResetPassword({
        data: { ...payload },
        handleSuccess: () => {
          history.push(PAGES.RESET_SUCCESSFUL_PAGE);
        },
        handleError: (errorMsg) => {
          setError('Password', {
            type: 'manual',
            message: errorMsg,
          });
        },
      }),
    );
  };

  return (
    <BaseLayout noLogoBox>
      <ForgotPasswordCard
        title={t('resetPassword.title')}
        subtitle={t('resetPassword.newPassword.subtitle')}
      >
        <FormWrap>
          <FormContainer>
            <Controller
              control={control}
              rules={{
                required: true,
              }}
              render={({ field, fieldState }) => (
                <PasswordInput
                  label={t('loginFluent.password')}
                  {...field}
                  {...fieldState}
                />
              )}
              name="Password"
              defaultValue=""
            />
          </FormContainer>
          <BaseLayoutCta
            buttonProps={{
              type: 'submit',
              title: t('resetPassword.newPassword.savePassword'),
              onClick: handleSubmit(onSubmit),
            }}
            fullWidth
          />
        </FormWrap>
      </ForgotPasswordCard>
    </BaseLayout>
  );
};

export default ResetPasswordPage;
